import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Grid, TableContainer } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import Table from "components/UpdateUi/Table/Table";
import { parseDateMDY } from "utils/Utils";
import { InstallmentTable } from "assets/properties/properties";
import Button from "components/CustomButtons/Button.js";
import { formatAmount } from "utils/Utils";

const RepaymentInstallment = ({
  installmentData,
  closeModal,
  classes,
}) => {
    const [installments, setinstallments] = useState([]);
    
  const handleCancelUser = () => {
    closeModal();
  };
  useEffect(()=>{
    if(installmentData?.length){
        parseIndicatorData(installmentData)
    }
  },
  [installmentData])
  const parseIndicatorData = async (res) => {
        let reportData = [];
        res &&
          res?.forEach((decisionDetails, index) => {
            let row = {
              label: index + 1,
              principalAmount: formatAmount(decisionDetails?.principalAmount),
              openingBalance: formatAmount(decisionDetails?.openingBalance),
              interestAmount: formatAmount(decisionDetails?.interestAmount),
              installmentAmount: formatAmount(decisionDetails?.installmentAmount),
              date: parseDateMDY(decisionDetails?.installmentDueDate),
            };
            reportData.push(row);
          });
          setinstallments(reportData);
        };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label="Repayment Schedule"
        />
      </Grid>
      {installments.length > 0 &&
      <TableContainer>
            <Table
              columns={InstallmentTable}
              rows={installments}
              styles="style"
            />
          </TableContainer>
    }
    <Grid container>
                <Grid item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{ textAlign: "end" }}
                >
                  <Button
                    style={{ margin: "5px" }}
                    size="small"
                    className={classes.nextButton}
                    onClick={() => closeModal()}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
      </Grid>
  );
};
RepaymentInstallment.propTypes = {
  classes: PropTypes.object,
};
export default RepaymentInstallment;